export default __webpack_public_path__ + "b6fdacf0e75649debfb1486863364158.svg";